var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { Loader } from 'modules/Loader';
import { Falcon } from 'modules/macro';
import { useMenuContext } from './useMenuContext';
import { IconContainer, StyledItem } from './styled';
export const MenuItem = forwardRef((props, ref) => {
    const { children, disabled, loading, selected, onClick, onMouseOver, onMouseOut, closeOnClick = true } = props, rest = __rest(props, ["children", "disabled", "loading", "selected", "onClick", "onMouseOver", "onMouseOut", "closeOnClick"]);
    const { controlled, close } = useMenuContext();
    const handleSelect = (event) => {
        if (controlled) {
            event.preventDefault();
        }
    };
    const handleClick = (event) => __awaiter(void 0, void 0, void 0, function* () {
        if (disabled || loading) {
            return;
        }
        yield (onClick === null || onClick === void 0 ? void 0 : onClick(event));
        if (closeOnClick) {
            close();
        }
    });
    const handleMouseOver = (event) => {
        if (disabled || loading) {
            return;
        }
        onMouseOver === null || onMouseOver === void 0 ? void 0 : onMouseOver(event);
    };
    const handleMouseOut = (event) => {
        if (disabled || loading) {
            return;
        }
        onMouseOut === null || onMouseOut === void 0 ? void 0 : onMouseOut(event);
    };
    const handlePointerLeave = (event) => {
        event.preventDefault();
    };
    const handlePointerMove = (event) => {
        event.preventDefault();
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            const searchElement = document.querySelector('input');
            searchElement === null || searchElement === void 0 ? void 0 : searchElement.focus();
        }
    };
    const handlers = {
        onClick: handleClick,
        onSelect: handleSelect,
        onKeyDown: handleKeyDown,
        onPointerMove: handlePointerMove,
        onPointerLeave: handlePointerLeave,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
    };
    return (<StyledItem ref={ref} disabled={disabled || loading} closeOnClick={false} {...handlers} {...rest}>
      {children}
      {selected && !loading && (<IconContainer>
          <Falcon $color="gray.900" icon="check" sourceConfig={{ family: 'classic', style: 'solid' }}/>
        </IconContainer>)}
      {loading && (<IconContainer>
          <Loader size="xs"/>
        </IconContainer>)}
    </StyledItem>);
});
